<template>
    <main id="mainCtrl">
        <QuestionModerationDialog ref="questionDialog" :specialities="specialities" @updated="updateTable"/>

        <v-table id="questionsTableTable"
                 request-uri="questionsTable/getList"
                 pagesize="100"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="90">
                        Создана
                    </v-th>
                    <v-th name="number" sort="number" width="70">
                        № вопроса
                    </v-th>
                    <v-th name="user_name" sort="user_name" width="80">
                        Автор
                    </v-th>
                    <v-th name="user_sex" sort="user_sex" width="40">
                        Пол
                    </v-th>
                    <v-th name="user_age" sort="user_age" width="45">
                        Воз
                    </v-th>
                    <v-th name="title" sort="title">
                        Тема
                    </v-th>
                    <v-th name="text" sort="text">
                        Текст
                    </v-th>
                    <v-th name="doctor_speciality_id" sort="doctor_speciality_id" width="80">
                        Раздел
                    </v-th>
                    <v-th name="is_payable" sort="price" width="60">
                        Вид
                    </v-th>
                    <v-th name="publishedModerated" sort="published, moderated_at" width="30">
                        М
                    </v-th>
                    <v-th name="refundStatus" width="70">
                        Возврат
                    </v-th>
                    <v-th name="unpublish_reason" sort="unpublish_reason">
                        Причина отклонения
                    </v-th>
                    <v-th name="answersCount" width="30" tooltip="Ответов всего">
                        <i class="fa fa-comment"/>
                    </v-th>
                    <v-th name="doctorAnswersCount" width="30" tooltip="Ответов врачей">
                        <i class="fa fa-comment" style="font-weight: 500"/><i class="fa fa-user-doctor"/>
                    </v-th>
                    <v-th name="source" sort="source" width="30" tooltip="Источник вопроса">
                        Ис
                    </v-th>
                    <v-th name="refundDate" width="70">
                        Возв.дата
                    </v-th>
                    <v-th name="refundError" width="100">
                        Ошибка возврата
                    </v-th>
                    <v-th name="closed" width="70">
                        Закрыт
                    </v-th>
                    <v-th name="turned_into_payable" sort="free_question_id" width="40" tooltip="Перевод из бесплатного в платный">
                        Б-П
                    </v-th>
                    <v-th name="is_anonym" sort="is_anonym" width="40" tooltip="Анонимно">
                        <i class="fa fa-eye-slash"/>
                    </v-th>
                    <v-th name="moderated_at" width="80" tooltip="Дата проверки">
                        Пров.дата
                    </v-th>
                    <v-th name="updated_at" sort="updated_at" width="80" tooltip="Дата редактирования вопроса">
                        Изм.дата
                    </v-th>
                    <v-th name="is_hidden" sort="hidden_at" width="80">
                        Скрыт
                    </v-th>
                </v-tr>

                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="number" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="user_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="user_sex" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { text: 'Ж', value: 'FEMALE' },
                                { text: 'М', value: 'MALE' }
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="user_age" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="title" :debounce="true"  v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="text" :debounce="true"  v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="doctor_speciality_id" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                ...specialities
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="is_payable" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: 'PAYABLE', text: 'Платный' },
                                { value: 'FREE', text: 'Бесплатный' },
                                { value: 'INDIVIDUAL', text: 'Индивидуальный' },
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="publishedModerated" v-slot="{filter}">
                        <select class="far" v-model="filter.value">
                            <option value=""></option>
                            <option value="N">&#xf0fe; Новый</option>
                            <option value="1">&#xf00c; Опубликованный</option>
                            <option value="0">&#xf00d; Отклоненный</option>
                        </select>
                    </v-th>
                    <v-th name="refundStatus" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Да' },
                                { value: '0', text: 'Нет' },
                                { value: '-1', text: 'Ошибка' },
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="unpublish_reason" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="answersCount"/>
                    <v-th name="doctorAnswersCount"/>
                    <v-th name="source" v-slot="{filter}">
                        <select class="far" v-model="filter.value">
                            <option value=""></option>
                            <option class="far" value="SITE">&#xf108; Сайт</option>
                            <option class="far" value="MOBILE">&#xf10b; Mobile</option>
                            <option class="fab"  value="ANDROID">&#xf17b; Андроид</option>
                            <option class="fab" value="IOS">&#xf179; iOs</option>
                        </select>
                    </v-th>
                    <v-th name="refundDate" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="refundError" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="closed" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { text: 'Автоматически', value: 'AUTO' },
                                { text: 'Вручную ', value: 'BY_USER' },
                                { text: 'Удален ', value: 'DELETED' },
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="turned_into_payable" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Да' },
                                { value: '0', text: 'Нет' },
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="is_anonym" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { text: 'Да', value: '1' },
                                { text: 'Нет', value: '0' }
                            ]"
                        ></v-select>
                    </v-th>
                    <v-th name="moderated_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="updated_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="is_hidden" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { text: 'Да', value: '1' },
                                { text: 'Нет', value: '0' }
                            ]"
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer"
                      :id="'qt-tr-' + item.id"
                      @click="(row, event) => handleRowClick(event, item, row)"
                >
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDateWithShortYearAndMonth }}
                        <br>
                        {{ item.created_at | formatTime }}
                    </v-td>
                    <v-td name="number" highlight="*">
                        {{ item.number }}
                    </v-td>
                    <v-td name="user_name">
                        {{ item.user_name }}
                    </v-td>
                    <v-td name="user_sex" align="center" highlight="*">
                        {{ item.user_sex === 'MALE' ? 'М' : (item.user_sex === 'FEMALE' ? 'Ж': '') }}
                    </v-td>
                    <v-td name="user_age">
                        {{ item.user_age }}
                    </v-td>
                    <v-td name="title">
                        {{ item.title }}
                    </v-td>
                    <v-td name="text">
                        <div>
                            {{ item.text }}
                        </div>
                        <div class="comma">
                          <template v-for="filename in item.files" >
                            <a v-if="filename==='deletedFile'" href="#" @click.prevent>
                              <i class="fa fa-file-xmark"/>&nbsp;Файл удален
                            </a>
                            <a v-else :href="prepareFileUrl(filename)" target="_blank">
                              <i class="fa fa-user" v-if="filename.includes('/photo/')"></i>
                              <i class="fa fa-file" v-else></i>&nbsp;
                              {{filename.replace(/^.*[\\\/]/, '')}}
                            </a>
                          </template>
                        </div>
                    </v-td>
                    <v-td name="doctor_speciality_id" highlight="*">
                        {{ item.doctorSpeciality?.name }}
                    </v-td>
                    <v-td name="is_payable" highlight="*">
                        {{ item.price }}
                    </v-td>
                    <v-td name="publishedModerated" align="center" highlight="*">
                        <span v-if="!item.moderated" v-tooltip="'Новый'"><i class="far fa-plus-square"></i></span>
                        <template v-else>
                            <span v-if="item.published" v-tooltip="'Опубликован'"><i class="far fa-check"></i></span>
                            <span v-else v-tooltip="'Отклонен'"><i class="fa fa-times"></i></span>
                        </template>
                    </v-td>
                    <v-td name="refundStatus" highlight="*">
                        {{ !item.refund?.refund_status ? 'нет' : (refundStatuses[item.refund.refund_status] ?? 'Неизвестно') }}
                    </v-td>
                    <v-td name="unpublish_reason">
                        {{ item.unpublish_reason }}
                    </v-td>
                    <v-td name="answersCount">
                        {{ item.answersCount }}
                    </v-td>
                    <v-td name="doctorAnswersCount">
                        {{ item.doctorAnswersCount }}
                    </v-td>
                    <v-td name="source" align="center" highlight="*">
                        <span v-if="item.source === 'SITE'" v-tooltip="'Сайт'"><i class="fa fa-desktop"></i></span>
                        <span v-if="item.source === 'MOBILE'" v-tooltip="'Mobile'"><i class="far fa-mobile"></i></span>
                        <span v-if="item.source === 'ANDROID'" v-tooltip="'Android'"><i class="fab fa-android"></i></span>
                        <span v-if="item.source === 'IOS'" v-tooltip="'iOs'"><i class="fab fa-apple"></i></span>
                    </v-td>
                    <v-td name="refundDate" highlight="*">
                        {{ item.refund?.updated_at | formatDateTime }}
                    </v-td>
                    <v-td name="refundError">
                        {{ item.refund?.cancellation_reason }}
                    </v-td>
                    <v-td name="closed" highlight="*">
                        {{ item.deleted_at ? 'Удален' : (item.closed_at ? (item.closed_by_account_id === 'AUTO' ? 'Авто' : 'Вручную') : '') }}
                    </v-td>
                    <v-td name="turned_into_payable" highlight="*">
                        {{ item.free_question_id ? 'да' : '' }}
                    </v-td>
                    <v-td name="is_anonym" highlight="*">
                        {{ item.is_anonym ? 'да' : '' }}
                    </v-td>
                    <v-td name="moderated_at" align="center" highlight="*">
                        <span v-if="item.changelogLastModerated !== null"
                              v-tooltip="item.changelogLastModerated.created_at | formatTime">
                            {{ item.changelogLastModerated.created_at | formatDateWithShortYearAndMonth }}
                        </span>
                    </v-td>
                    <v-td name="updated_at" highlight="*">
                        <span v-tooltip="item.updated_at | formatTime">
                            {{ item.updated_at | formatDateWithShortYearAndMonth }}
                        </span>
                    </v-td>
                    <v-td name="is_hidden" highlight="*">
                        {{ item.hidden_at ? 'да' : '' }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import QuestionModerationDialog from "@dialogs/admin/consult/QuestionModeration";

export default {
    components: {
        QuestionModerationDialog
    },
    props: {
        specialities: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            refundStatuses: {
                'pending': 'да',
                'succeeded': 'да',
                'canceled': 'ошибка',
            },
        };
    },
    filters: {
        formatTime(time) {
            function isDateEmpty(date) {
                return (
                    (typeof date === 'undefined') ||
                    (date === null) ||
                    (date === '') ||
                    (date === '0000-00-00') ||
                    (date === '0000-00-00 00:00:00')
                );
            }
            if (isDateEmpty(time)) {
                return '';
            }

            if (time.substr(2, 1) === ':') {
                return time.substr(0, 5);
            }

            return time.substr(11, 5);
        },
    },
    methods: {
        updateTable() {
            this.$refs.table.update();
        },
        handleRowClick(event, item, row) {
            if (item.deleted_at) {
                return;
            }

            row.startLoadingAnimation();

            this.$refs.questionDialog.show(item.id)
                .then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());
        },
        prepareFileUrl(fileUrl) {
            return fileUrl.indexOf('http') === -1 ? '//' + fileUrl : fileUrl;
        },
    },
}
</script>
